import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const publisherInvoiceApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPublisherInvoices: builder.query({
      query: (publisherId) => ({
        url: `/publishers/${publisherId}/revenues`
      }),
      providesTags: (result = [], error, publisherId) => [{ type: 'PublisherInvoice', id: `${publisherId}:LIST` } ],
    }),
    getPublisherInvoice: builder.query({
      query: ([publisherId, year, month]) => ({
        url: `/publishers/${publisherId}/revenues/${year}/${month}`
      }),
      providesTags: (result = [], error, [publisherId, year, month]) => [{ type: 'PublisherInvoice', id: `${publisherId}:${year}:${month}` } ],
    }),
    updatePublisherInvoice: builder.mutation({
      query: (publisherInvoice) => ({
        url: `/publishers/${publisherInvoice.publisherId}/revenues/${publisherInvoice.year}/${publisherInvoice.month}`,
        method: 'PUT',
        body: publisherInvoice
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, {publisherId, year, month}) => [
        { type: 'PublisherInvoice', id: `${publisherId}:LIST` },
        { type: 'PublisherInvoice', id: `${publisherId}:${year}:${month}` },
        { type: 'Invoice', id: `${year}/${month}` }
      ],
    }),
    destroyPublisherInvoice: builder.mutation({
      query: ([publisherId, year, month]) => ({
        url: `/publishers/${publisherId}/revenues/${year}/${month}`,
        method: 'DELETE'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.deleted")}),
      invalidatesTags: (result, error, [publisherId, year, month]) => [
        { type: 'PublisherInvoice', id: `${publisherId}:LIST` },
        { type: 'PublisherInvoice', id: `${publisherId}:${year}:${month}` },
        { type: 'Invoice', id: `${year}/${month}` },
      ],
    }),
    finalizePublisherInvoice: builder.mutation({
      query: ([publisherId, year, month]) => ({
        url: `/publishers/${publisherId}/revenues/${year}/${month}/finalize`,
        method: 'PUT'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("publisherInvoice.finalized")}),
      invalidatesTags: (result, error, [publisherId, year, month]) => [
        { type: 'PublisherInvoice', id: `${publisherId}:LIST` },
        { type: 'PublisherInvoice', id: `${publisherId}:${year}:${month}` },
        { type: 'Invoice', id: `${year}/${month}` },
      ],
    })
  }),
  overrideExisting: false
})

export const {
  useGetPublisherInvoicesQuery,
  useGetPublisherInvoiceQuery,
  useUpdatePublisherInvoiceMutation,
  useFinalizePublisherInvoiceMutation,
  useDestroyPublisherInvoiceMutation
} = publisherInvoiceApiSlice
